



























import {Component, Vue} from 'vue-property-decorator'
import productModule from '@/store/module/ProductModule';
import {Container} from "typescript-ioc";
import ProductConfigApi, {PconfigEditForm} from '@/module/device/ProductConfigApi';
import ObjectUtil from "tools-ts/src/util/ObjectUtil";

@Component({
  components: {},
})
export default class ProductConfigView extends Vue {

  private pconfigApi = Container.get(ProductConfigApi)

  private get product() {
    return productModule.active
  }

  private form: PconfigEditForm = {
    productId: this.product.id,
    support: ObjectUtil.deepClone(this.product.config.support)
  }

  private oldForm = ObjectUtil.deepClone(this.form)

  private async editProductConfig() {
    const config = await this.pconfigApi.edit(this.form)
    this.$message.success("保存成功")
    this.oldForm = ObjectUtil.deepClone(this.form)
    const product = this.product
    product.config = config
    productModule.activate(product)
  }

  private cancelEdit() {
    this.form = ObjectUtil.deepClone(this.oldForm)
  }

  private get btnDisabled() {
    return JSON.stringify(this.form) == JSON.stringify(this.oldForm)
  }
}
